import React, { useState, useRef, useEffect } from "react";
import { crossIcon } from "../../assets/images";
import "./Tooltip.css";

const Tooltip = (props) => {
  let showCrossIcon = props.crossIcon !== null ? props.crossIcon : true
  let timeout;
  const ref = useRef();
  const [active, setActive] = useState(false);

  const showTip = () => {
    timeout = setTimeout(() => {
      setActive(true);
    }, props.delay || 400);
  };

  const hideTip = () => {
    clearInterval(timeout);
    setActive(false);
  };

  const handleClickEvent = (event) => {
    if (event.target?.id === "url") {
      window.open("https://thetrainingassociates.com/", '_blank');
    } else {
      hideTip()
    }

  }
  useEffect(() => {
    document.addEventListener("click", handleClickEvent, true);
    return () => {
      document.removeEventListener("click", handleClickEvent, true);
    };
    // eslint-disable-next-line
  }, [ref]);

  return (
    <div
      className="Tooltip-Wrapper"
      // When to show the tooltip
      onMouseEnter={showTip}
      onClick={showTip}
    >
      {/* Wrapping */}
      {props.children}
      {active && (
        <div className={`Tooltip-Tip ${props.direction || "top"} ${props?.accountSettingStyle ? "accountSettingStyle" : ''}`} id="info">
          {/* Content */}
          <div className="d-flex justify-content-between">
            {props.content}
            {showCrossIcon && <div className="pointer">
              <img src={crossIcon} alt="" />
            </div>}
          </div>
        </div>
      )}
    </div>
  );
};

export default Tooltip;
